import Member from '../../assets/profile.jpg'
import { EyeFilled } from '@ant-design/icons';

import { Col, Row, Tag } from 'antd'

import * as echarts from 'echarts/dist/echarts.js';
import Template from '../../Template'
import { CustomTable, ECharts, HeaderComp, Spiner } from '../../components';
import { Link } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { GET_ALL_STATUS, GET_LEADS } from '../../Graphql/queries/getQueries';
import { useState } from 'react';
import { OverviewChart } from '../../services';
import { useEffect } from 'react';
import { offsetLimitPagination } from '@apollo/client/utilities';

const EnquireDashboard = () => {
    const [page, setPage] = useState(1);

    const { loading: leads_loading, data: leads_data } = useQuery(GET_LEADS, {
        variables: { count: 8, page },
        fetchPolicy: 'network-only'

    })
    const { loading, data } = useQuery(GET_ALL_STATUS)
    const OverviewPieChartData = data?.Status?.nodes.filter((item) => item.total > 0).map((item) => {
        return {
            value: item.total,
            name: item.text,
            itemStyle: { color: item.color, emphasis: { shadowBlur: 25, shadowColor: item.color } }
        }
    })
    const overviewOption = {
        baseOption: {
            legend: {
                orient: 'vertical',
                right: '30%',
                top: '30%',
                icon: 'circle',
                selected: 'false'
            },

            series: [

                {
                    name: 'Overview',
                    type: 'pie',
                    radius: [60, 90],
                    center: ['30%', '50%'],
                    // roseType: 'area',
                    itemStyle: {
                        borderRadius: 0
                    },
                    label: {
                        show: false
                    },
                    emphasis: {
                        label: {
                            show: true
                        }
                    },
                    data: OverviewPieChartData
                }
            ]
        },
        media: [
            {
                query: {
                    maxWidth: 600
                },
                option: {
                    legend: {
                        // right: 'left',
                        left: 0,
                        bottom: '10%',
                        orient: 'horizontal'
                    },
                    series: [
                        {
                            radius: [40, '50%'],
                            center: ['50%', '30%']
                        },

                    ]
                }
            },
        ]


    };

    const columns = [{
        title: 'Assignee',
        dataIndex: 'assignee',
        key: 'assignee',
        render: (_, record) => {
            return (
                <Row>
                    <Col span={8}>
                        <img style={{ width: 40, height: 40, borderRadius: '50%' }} src={record.image} />
                    </Col>
                    <Col span={16}>
                        <div>{record.name}</div>
                    </Col>

                </Row>
            );
        },
    },
    {
        title: 'Lead Name',
        dataIndex: 'lead_name',
        key: 'lead_name',
    },
    {
        title: 'Campaign',
        dataIndex: 'campaign',
        key: 'campaign',
    },
    {
        title: 'Submission Date',
        dataIndex: 'submission_date',
        key: 'submission_date',
    },
    {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        render: (status) => <Tag color={status.color}>{status.text}</Tag>
    },
    {
        title: 'View/edit',
        dataIndex: 'view_edit',
        key: 'view_edit',
        align: 'center',
        render: (id) => {
            return (
                <>
                    <Link to={`/enquiry/${id}`}>
                        <EyeFilled style={{ color: '#8D8D8D', fontSize: 20 }} onClick={() => console.log('clicked')} />
                    </Link>
                </>
            );
        },
    },
    ];
    const dataSource = leads_data?.Leads?.nodes.map((item) => {
        let userInfo
        for (const user of item.user) {
            userInfo = {
                key: item.id,
                image: Member,
                name: user.name,
                lead_name: item.name,
                campaign: item.campaign,
                submission_date: user.create_date,
                status: {
                    text: item.status.text,
                    color: item.status.color
                },
                view_edit: item.id

            }
        }
        return userInfo
    })


    return (
        <Template
            headerTitle={['Enquiry Dashboard']}
            hasFilters={true}
        >

            {/* ::::::::::Overview Pie Chart::::::::::: */}

            <OverviewChart option={overviewOption} title="Overview" loading={loading} />

            {/* ::::::::::Leads Table::::::::::: */}

            <div className="item_comp" >
                <HeaderComp title="Leads Table" btnType='link' path='new_lead' />
                <CustomTable data={dataSource} columns={columns} scrollable={1000} pagination onPageChange={(page) => setPage(page)} page={page} loading={leads_loading} total={leads_data?.Leads.total} />
            </div>
        </Template>
    )
}

export default EnquireDashboard
